// Packages
import React, { Fragment } from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
// Utils
import getValue from "object-getvalue"

// Components
import Icon from "components/Stacker/components/Icon/Icon"

// Styles
import "./ProductName.scss"
import { useI18nContext } from "i18n/i18n-react"

// this should hold the Product Details on PDP page.
function ProductName({
  isGiftCard,
  formattedValue,
  discountedPrice,
  isEngagementProduct,
  isPriceDisclaimerEnabled = false,
  defaultProductPrice = "",
  isShopTheLookPage,
  productName,
  collection,
  categoryPath,
  showIcon,
  showProductDetails,
  showAvailability,
  availabilityTextKey,
  price,
  displayAffirm,
  priceList,
  productTheme,
  isCsAgent,
  gender,
}) {
  const { LL } = useI18nContext()
  const renderProductName = () => {
    if (isShopTheLookPage) {
      return <h2 className="product-title text-black">{productName}</h2>
    }
    return <h1 className="product-title">{productName}</h1>
  }

  const renderProductPrice = () => {
    if (!isGiftCard && !isEngagementProduct) {
      return (
        <p className="product-price text-black">
          {discountedPrice ? (
            <Fragment>
              <strike>{formattedValue}</strike>
              <span className="error-text">{discountedPrice}</span>
            </Fragment>
          ) : (
            formattedValue && formattedValue
          )}
          {!formattedValue &&
            defaultProductPrice.length > 0 &&
            defaultProductPrice}
          {isPriceDisclaimerEnabled && (formattedValue || discountedPrice) && (
            <span className="price-disclaimer">
              {`(${LL.generic.priceDisclaimer()})`}
            </span>
          )}
        </p>
      )
    }
    return null
  }

  let EUR_PRICE = ""
  let pageType
  if (gender === "FEMALE") {
    pageType = "category"
  } else if (gender === "MALE") {
    pageType = "banner"
  } else {
    pageType = "product"
  }
  if (Array.isArray(priceList) && priceList.length) {
    priceList.every((priceItem) => {
      if (getValue(priceItem, "currencyIso", "") === "EUR") {
        EUR_PRICE = getValue(priceItem, "formattedValue", "")
        return false
      }
      return true
    })
  }

  return (
    <div className="ProductName">
      {collection && (
        <p className="collection-title">
          <a href={`${categoryPath}.html`}>{collection}</a>
        </p>
      )}
      <div className="product-title-wrapper">
        {renderProductName()}
        {!isEngagementProduct && renderProductPrice()}
        {EUR_PRICE.length > 0 && (
          <p className="product-price product-price_eur hide">{EUR_PRICE}</p>
        )}
      </div>
      {showIcon && (
        <p
          className={classNames("icon-wrapper", {
            expanded: showProductDetails,
          })}
        >
          <Icon
            additionalClassNames="down-chevron "
            iconName="icon-right-chevron"
          />
        </p>
      )}
    </div>
  )
}

ProductName.propTypes = {
  collection: PropTypes.string,
  categoryPath: PropTypes.string,
  isShopTheLookPage: PropTypes.bool,
  productName: PropTypes.string,
  isEngagementProduct: PropTypes.bool,
  discountedPrice: PropTypes.number,
  formattedValue: PropTypes.string,
  defaultProductPrice: PropTypes.string,
  isGiftCard: PropTypes.bool,
  showIcon: PropTypes.bool,
  showProductDetails: PropTypes.bool,
  showAvailability: PropTypes.bool,
  availabilityTextKey: PropTypes.string,
  isPriceDisclaimerEnabled: PropTypes.bool,
  price: PropTypes.number,
  displayAffirm: PropTypes.bool,
  productTheme: PropTypes.string,
  priceList: PropTypes.array,
  isCsAgent: PropTypes.bool,
  gender: PropTypes.string,
}

export default ProductName
